import { AlertType } from '../enums/alert-type.enum';

export class Alert {
  type: AlertType;
  message: string;
}
